@use "../../styles/breakpoint.module.scss" as *;

.root {
    composes: grid from "../../styles/composable/layout.module.css";
    align-items: center;

    @media ($below-tablet) {
        --labui-grid-gap: 0;
    }
}

.heading {
    grid-column: span 5;

    @media ($above-tablet) {
        position: sticky;
        top: 0;
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    @media ($below-tablet) {
        grid-column: 1 / -1;
        margin-bottom: var(--spacer-32);
        padding-bottom: var(--spacer-32);
        border-bottom: 1px solid var(--color-contrast);
    }
}

.carouselContainer {
    grid-column: 7 / span 6;

    @media ($below-tablet) {
        grid-column: 1 / -1;
    }
}

.carousel > * {
    @media ($above-tablet) {
        display: flex;
        gap: var(--spacer-24);
        flex-direction: column;
        white-space: normal;
    }

    > * {
        width: 100%;

        @media ($below-tablet) {
            &:not(:last-child) {
                margin-right: var(--grid-gap);
            }
        }

        @media ($above-mobile) and ($below-tablet) {
            width: calc(50% - var(--spacer-24) / 2);
        }
    }
}

.reviewCardWrapper {
    border-radius: var(--border-radius-md);
}

.reviewCard {
    margin: 0;
    padding: var(--spacer-24);
    display: flex;
    gap: var(--spacer-24);
    align-items: center;
}

.reviewContent {
    flex-grow: 1;
}

.rating {
    margin-bottom: var(--spacer-12);
    font-size: 0;
}

.star {
    width: 24px;
    height: 24px;
}

.starFilled {
    composes: star;
    color: var(--paprika);
}

.starEmpty {
    composes: star;
    color: var(--mid-grey);
}

.quoteHeading {
    font-size: var(--font-p-16);
}

.quote {
    margin: var(--spacer-16) 0 0;
    font: var(--font-q-20);

    &::before {
        content: "“";
    }

    &::after {
        content: "”";
    }
}

.citation {
    margin-top: var(--spacer-16);
    font: var(--font-s-14);

    &::before {
        content: "— ";
    }
}

.imageWrapper {
    flex-shrink: 0;
    width: var(--spacer-200);
    height: var(--spacer-200);
}

.image {
    width: 100%;
    aspect-ratio: 1;
    object-fit: cover;
}
